import styled from 'styled-components';
import {
  AppVimeoGalleryCollectionsIcon,
  AppVimeoGalleryCommentsIcon,
  AppVimeoGalleryLikesIcon,
  AppVimeoGalleryViewsIcon
} from '@elfsight/icons';
import { formatNumberWithCustomSeparator } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { classnamePrefix } from '../../../../../constants';
import { Share } from '../../../common';

export const Actions = ({
  data: { viewsCount, likesCount, collectionsCount, commentsCount, link },
  share,
  numbers,
  popup = false,
  mobile = false
}) => {
  const { textColor } = useSettings();

  return (
    <Component>
      {numbers && (
        <>
          {viewsCount > 0 && (
            <Item title="Views">
              <Icon _isInPopup={popup} _textColor={textColor}>
                <AppVimeoGalleryViewsIcon width="20" height="20" />
              </Icon>

              <Stats
                _isInPopup={popup}
                _textColor={textColor}
                _isMobile={mobile}
              >
                {formatNumberWithCustomSeparator(viewsCount, ',')}
              </Stats>
            </Item>
          )}

          {likesCount > 0 && (
            <Item title="Likes">
              <Icon _isInPopup={popup} _textColor={textColor}>
                <AppVimeoGalleryLikesIcon width="20" height="20" />
              </Icon>

              <Stats
                _isInPopup={popup}
                _textColor={textColor}
                _isMobile={mobile}
              >
                {formatNumberWithCustomSeparator(likesCount, ',')}
              </Stats>
            </Item>
          )}

          {collectionsCount > 0 && (
            <Item title="Collections">
              <Icon _isInPopup={popup} _textColor={textColor}>
                <AppVimeoGalleryCollectionsIcon width="20" height="20" />
              </Icon>

              <Stats
                _isInPopup={popup}
                _textColor={textColor}
                _isMobile={mobile}
              >
                {collectionsCount}
              </Stats>
            </Item>
          )}

          {commentsCount > 0 && (
            <Item title="Comments">
              <Icon _isInPopup={popup} _textColor={textColor}>
                <AppVimeoGalleryCommentsIcon width="20" height="20" />
              </Icon>

              <Stats
                _isInPopup={popup}
                _textColor={textColor}
                _isMobile={mobile}
              >
                {formatNumberWithCustomSeparator(commentsCount, ',')}
              </Stats>
            </Item>
          )}
        </>
      )}

      {share && (
        <Item>
          <Share link={link} popup={popup} mobile={mobile} />
        </Item>
      )}
    </Component>
  );
};

const Component = styled.div.attrs({
  className: `${classnamePrefix}-actions-component`
})`
  margin: 8px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const Item = styled.div.attrs({
  className: `${classnamePrefix}-actions-item`
})`
  display: flex;
  margin: 4px 20px 4px 0;
  align-items: center;
`;

const Icon = styled.div.attrs({
  className: `${classnamePrefix}-actions-icon`
})`
  display: flex;

  & svg {
    display: flex;
    margin-right: 2px;
    fill: ${({ _isInPopup, _textColor }) =>
      !_isInPopup && _textColor ? _textColor : ''};
  }
`;

const Stats = styled.div.attrs({
  className: `${classnamePrefix}-actions-stats`
})`
  font-size: ${({ _isMobile }) => (_isMobile ? '12px' : '14px')};
  line-height: ${({ _isMobile }) => (_isMobile ? '16px' : '20px')};
  color: ${({ _isInPopup, _textColor }) =>
    !_isInPopup && _textColor ? _textColor : 'rgb(26, 46, 59)'};
`;
